import { PeerTypeEnum } from '@workalizer/shared';
import { diffComparisonType } from '@workalizer/shared/types';
import { getPercentageDiff } from '@workalizer/shared/utils';
var createCountMetric = function (count, prevCount, teamAvg) { return ({
    count: count,
    userDiff: getPercentageDiff(prevCount, count),
    orgUnitAvgDiff: getPercentageDiff(teamAvg, count, {
        comparisonType: diffComparisonType.teamAverage
    })
}); };
var createMeetingsMetric = function (count, duration, prevCount, teamAvg) { return ({
    count: count,
    duration: duration,
    userDiff: getPercentageDiff(prevCount, count),
    orgUnitAvgDiff: getPercentageDiff(teamAvg, count, {
        comparisonType: diffComparisonType.teamAverage
    })
}); };
export var communicationByPeerType = function () {
    return [
        {
            peerType: PeerTypeEnum.TEAM_INTERNAL,
            drive: createCountMetric(25, 17, 20),
            chat: createCountMetric(45, 33, 37),
            meetings: createMeetingsMetric(18, '18h', 12, 15),
            gmail: createCountMetric(32, 25, 28)
        },
        {
            peerType: PeerTypeEnum.OTHER_TEAMS,
            drive: createCountMetric(12, 9, 10),
            chat: createCountMetric(28, 21, 24),
            meetings: createMeetingsMetric(10, '8h 30m', 8, 9),
            gmail: createCountMetric(14, 12, 13)
        },
        {
            peerType: PeerTypeEnum.MANAGER,
            drive: createCountMetric(8, 6, 7),
            chat: createCountMetric(15, 11, 13),
            meetings: createMeetingsMetric(6, '4h', 5, 5),
            gmail: createCountMetric(9, 8, 8)
        },
        {
            peerType: PeerTypeEnum.EXTERNAL,
            drive: createCountMetric(5, 4, 4),
            chat: createCountMetric(8, 6, 7),
            meetings: createMeetingsMetric(4, '2h 15m', 3, 3),
            gmail: createCountMetric(6, 5, 5)
        }
    ];
};
